(() => {
  if (window.theme.loadScriptOnce) return;
  const loads = new Map();
  const failed = new WeakSet();

  window.theme.loadScriptOnce = (elementName, url) => {
    if (!url || customElements.get(elementName)) return Promise.resolve();
    const src = new URL(url, document.baseURI).href;
    if (loads.has(src)) return loads.get(src);
    let resolveLoad;
    let rejectLoad;
    const pending = new Promise((resolve, reject) => {
      resolveLoad = resolve;
      rejectLoad = reject;
    });
    loads.set(src, pending);
    const existing = Array.from(document.scripts).find(script => script.src === src && !failed.has(script));
    const script = existing || document.createElement('script');
    const cleanup = () => {
      script.removeEventListener('load', onLoad);
      script.removeEventListener('error', onError);
    };
    const onError = () => {
      cleanup();
      failed.add(script);
      loads.delete(src);
      if (!existing) script.remove();
      rejectLoad(new Error(`Unable to load theme component: ${elementName}`));
    };
    const onLoad = () => {
      if (!customElements.get(elementName)) return onError();
      cleanup();
      resolveLoad();
    };
    script.addEventListener('load', onLoad, { once: true });
    script.addEventListener('error', onError, { once: true });
    if (!existing) {
      script.src = src;
      script.async = true;
      document.head.appendChild(script);
    }
    return pending;
  };

  const selector = '[data-eager-carousel-script]';
  const initialize = (root = document) => {
    const markers = Array.from(root.querySelectorAll(selector));
    if (root.matches?.(selector)) markers.unshift(root);
    markers.forEach(marker => {
      window.theme.loadScriptOnce('card-carousel', marker.dataset.eagerCarouselScript).catch(console.error);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
